/* Gebert & Weschka — Labortisch-Konfigurator (parametrisch, Three.js)
   Live-3D-Vorschau + Live-Preis. Braucht window.THREE (self-hosted ESM, wie gw-3d.js).
   Preise kommen als Verkaufsraten; der Server prüft jede Anfrage nach. */
(function () {
  "use strict";

  // ── Verkaufsraten je Bauteil (netto) ──
  var VK = {
    p2020: 5.04, p2040: 8.46, p3030: 8.28,       // €/m
    b3030: 0.446, b2020: 0.304, b45: 0.853,      // Winkel €/Stk
    tM8: 0.162, tM6: 0.142, cap: 0.267,          // Nutensteine/Kappen
    footLevel: 3.02, caster: 4.84,               // Füße €/Stk
  };
  var VAT = 1.19;
  var PITCH = { voll: 40, standard: 50, offen: 72 };
  var COL = { silber: 0xe3e7ec, schwarz: 0x34373e };

  // ── Profil-Materialien (gecacht je Farbe): Nut ist jetzt echte Geometrie, kein Bild ──
  var _mats = {};
  function getProfileMats(THREE, color, isBlack) {
    if (_mats[color]) return _mats[color];
    var m = {
      wall: new THREE.MeshStandardMaterial({ color: color, metalness: 0.62, roughness: 0.34, envMapIntensity: 1.3 }), // Nutwände/Mantel
      end: new THREE.MeshStandardMaterial({ color: color, metalness: 0.6, roughness: 0.42, envMapIntensity: 1.2 }),   // Stirnseiten + Fallback
      slot: new THREE.MeshStandardMaterial({ color: isBlack ? 0x24262b : 0xb3b8c0, metalness: 0.6, roughness: 0.5 }), // Füße/Rollen/Streben
    };
    _mats[color] = m; return m;
  }

  // ── Echte extrudierte T-Nut-Profilgeometrie (Konkurrenz-Look). Kanonische Geometrie
  //    je Querschnitt EINMAL gebaut + gecacht + geteilt; Instanz = Mesh + scale.z + Rotation. ──
  var REF_LEN = 1000, _profileGeo = {};

  // T-Nut-Querschnitt als geschlossene Shape (lokale XY, um 0 zentriert). Je Kante mittig
  // eine Nut mit eingezogener Lippe (Mund schmaler als Kammer = T-Aufweitung), 4 gefaste Ecken.
  function tnutShape(THREE, w, h, slot) {
    var m = Math.min(w, h), hw = w / 2, hh = h / 2, so = slot / 2, ci = slot * 0.62,
      d1 = m * 0.145, d2 = m * 0.30, c = m * 0.06;
    var s = new THREE.Shape();
    s.moveTo(-hw + c, -hh);
    s.lineTo(-so, -hh); s.lineTo(-so, -hh + d1); s.lineTo(-ci, -hh + d1);
    s.lineTo(-ci, -hh + d2); s.lineTo(ci, -hh + d2); s.lineTo(ci, -hh + d1);
    s.lineTo(so, -hh + d1); s.lineTo(so, -hh);
    s.lineTo(hw - c, -hh); s.lineTo(hw, -hh + c);
    s.lineTo(hw, -so); s.lineTo(hw - d1, -so); s.lineTo(hw - d1, -ci);
    s.lineTo(hw - d2, -ci); s.lineTo(hw - d2, ci); s.lineTo(hw - d1, ci);
    s.lineTo(hw - d1, so); s.lineTo(hw, so);
    s.lineTo(hw, hh - c); s.lineTo(hw - c, hh);
    s.lineTo(so, hh); s.lineTo(so, hh - d1); s.lineTo(ci, hh - d1);
    s.lineTo(ci, hh - d2); s.lineTo(-ci, hh - d2); s.lineTo(-ci, hh - d1);
    s.lineTo(-so, hh - d1); s.lineTo(-so, hh);
    s.lineTo(-hw + c, hh); s.lineTo(-hw, hh - c);
    s.lineTo(-hw, so); s.lineTo(-hw + d1, so); s.lineTo(-hw + d1, ci);
    s.lineTo(-hw + d2, ci); s.lineTo(-hw + d2, -ci); s.lineTo(-hw + d1, -ci);
    s.lineTo(-hw + d1, -so); s.lineTo(-hw, -so);
    s.lineTo(-hw, -hh + c);
    s.closePath();
    return s;
  }

  function getProfileGeo(THREE, key, w, h) {
    if (_profileGeo[key]) return _profileGeo[key];
    var slot = (Math.min(w, h) >= 30) ? 8 : 6, bev = Math.min(w, h) * 0.015;
    var geo = new THREE.ExtrudeGeometry(tnutShape(THREE, w, h, slot), {
      depth: REF_LEN, steps: 1, curveSegments: 1,
      bevelEnabled: true, bevelThickness: bev, bevelSize: bev, bevelOffset: 0, bevelSegments: 1
    });
    geo.translate(0, 0, -REF_LEN / 2);
    geo.computeVertexNormals();
    geo.userData.shared = true;        // schützt die gecachte Geometrie vor Rebuild-Dispose
    _profileGeo[key] = geo; return geo;
  }

  function stdProfile(a, b) {
    function near(v, t) { return Math.abs(v - t) <= 3; }
    if (near(a, 20) && near(b, 20)) return { key: "20x20", cw: 20, ch: 20 };
    if (near(a, 20) && near(b, 40)) return { key: "20x40", cw: 20, ch: 40 };
    if (near(a, 30) && near(b, 30)) return { key: "30x30", cw: 30, ch: 30 };
    return null;
  }

  // Ersatz-box(): Signatur box(w,h,d,x,y,z,m) unverändert. m gesetzt (slotMat) ODER Nicht-
  // Standard-Querschnitt → glatte Box; sonst geteilte T-Nut-Geometrie (scale.z + Rotation/Roll).
  function makeBox(THREE, g, M) {
    return function box(w, h, d, x, y, z, m) {
      var dims = [w, h, d], li = 0;
      if (h > dims[li]) li = 1;
      if (d > dims[li]) li = 2;
      var len = dims[li], others = [];
      for (var k = 0; k < 3; k++) if (k !== li) others.push({ v: dims[k], axis: k });
      others.sort(function (p, q) { return p.v - q.v; });
      var std = m ? null : stdProfile(others[0].v, others[1].v);
      if (!std) {
        var fb = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), m || M.end);
        fb.position.set(x, y, z); g.add(fb); return fb;
      }
      var mesh = new THREE.Mesh(getProfileGeo(THREE, std.key, std.cw, std.ch), [M.end, M.wall]);
      mesh.scale.z = len / REF_LEN;
      if (li === 0) mesh.rotation.y = Math.PI / 2;        // Länge X
      else if (li === 1) mesh.rotation.x = -Math.PI / 2;  // Länge Y
      if (std.cw !== std.ch) {                            // 20×40: 40er-Seite korrekt rollen
        var canonYWorld = (li === 1) ? 2 : 1;
        if (others[1].axis !== canonYWorld) mesh.rotateZ(Math.PI / 2);
      }
      mesh.position.set(x, y, z); g.add(mesh); return mesh;
    };
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function eur(n) { return n.toLocaleString("de-DE", { style: "currency", currency: "EUR" }); }

  // ── BOM + Preis (spiegelt lib/table-pricing.ts) ──
  function compute(cfg) {
    var L = clamp(cfg.L, 800, 2400), W = clamp(cfg.W, 500, 900), H = clamp(cfg.H, 700, 1100);
    var pitch = PITCH[cfg.coverage] || 50;
    var legLen = H - 60;
    var legM = 4 * legLen / 1000;
    var perimM = (2 * L + 2 * W) / 1000;
    var crossN = Math.max(0, Math.ceil(L / 450) - 1);
    var crossM = crossN * W / 1000;
    var slatN = Math.max(2, Math.round(W / pitch));
    var slatM = slatN * L / 1000;
    var p2040 = perimM + crossM + slatM, p3030 = legM, p2020 = 0, shelfSlatN = 0;
    if (cfg.shelf) { p2040 += (2 * L + 2 * W) / 1000; shelfSlatN = Math.max(2, Math.round(W / 90)); p2020 += shelfSlatN * L / 1000; }
    var spineOn = !!cfg.spine || !!cfg.upperShelf, upperOn = !!cfg.upperShelf, spineH = 450, upperSlatN = 0;
    if (spineOn) p3030 += 2 * spineH / 1000;
    if (upperOn) { p2040 += 2 * L / 1000; upperSlatN = 4; p2020 += upperSlatN * L / 1000; }
    var b3030 = 8 + (spineOn ? 4 : 0), b2020 = 4 + crossN * 2 + (cfg.shelf ? 4 : 0) + (upperOn ? 4 : 0), b45 = cfg.braces ? 4 : 0;
    var tM8 = b3030 * 2, tM6 = b2020 * 2 + b45 * 2 + slatN * 2 + shelfSlatN * 2 + upperSlatN * 2, caps = 4 + slatN * 2;
    var mat = p2040 * VK.p2040 + p3030 * VK.p3030 + p2020 * VK.p2020 +
      b3030 * VK.b3030 + b2020 * VK.b2020 + b45 * VK.b45 +
      tM8 * VK.tM8 + tM6 * VK.tM6 + caps * VK.cap +
      4 * (cfg.foot === "caster" ? VK.caster : VK.footLevel);
    var cuts = 4 + 4 + crossN + slatN + (cfg.shelf ? 4 + shelfSlatN : 0) + (spineOn ? 2 : 0) + (upperOn ? 2 + upperSlatN : 0);
    var handling = 19 + 0.55 * cuts;
    var vkNet = mat + handling;
    var kg = p2040 * 0.82 + p3030 * 0.80 + p2020 * 0.47 + 1.2;
    return {
      vkNet: Math.round(vkNet * 100) / 100, vkGross: Math.round(vkNet * VAT * 100) / 100,
      meters: Math.round((p2040 + p3030 + p2020) * 10) / 10, weightKg: Math.round(kg * 10) / 10,
      slatN: slatN, crossN: crossN, legLen: legLen, pitch: pitch, shelfSlatN: shelfSlatN, cuts: cuts,
      spineOn: spineOn, upperOn: upperOn, spineH: spineH, upperSlatN: upperSlatN,
    };
  }

  // ── Styles ──
  function injectCss() {
    if (document.getElementById("gwt-css")) return;
    var s = document.createElement("style"); s.id = "gwt-css";
    s.textContent = [
      ".gwt{--bl:#2f6fed;--ink:#0a0e14;--ln:#e1e4e9;--mut:#8a909a;display:grid;grid-template-columns:1fr 320px;gap:18px;font-family:Archivo,'Segoe UI',Arial,sans-serif;color:#16191f}",
      "@media(max-width:820px){.gwt{grid-template-columns:1fr}}",
      ".gwt-stage{position:relative;background:linear-gradient(180deg,#eef1f5,#dde3ea);border:1px solid var(--ln);border-radius:10px;min-height:420px;overflow:hidden}",
      ".gwt-stage canvas{display:block;width:100%;height:100%}",
      ".gwt-hint{position:absolute;left:12px;bottom:10px;font:11px/1.4 'IBM Plex Mono',monospace;color:var(--mut);letter-spacing:.04em}",
      ".gwt-panel{display:flex;flex-direction:column;gap:14px}",
      ".gwt-grp{border:1px solid var(--ln);border-radius:10px;padding:12px 13px}",
      ".gwt-grp h4{margin:0 0 9px;font:600 10px/1 'IBM Plex Mono',monospace;letter-spacing:.12em;text-transform:uppercase;color:var(--mut)}",
      ".gwt-row{display:flex;justify-content:space-between;align-items:center;font-size:13px;margin:7px 0}",
      ".gwt-row b{font-weight:700}",
      ".gwt-slider{width:100%;accent-color:var(--bl);margin-top:2px}",
      ".gwt-seg{display:flex;gap:6px;flex-wrap:wrap}",
      ".gwt-seg button{flex:1;min-width:52px;padding:7px 4px;border:1px solid var(--ln);background:#fff;border-radius:7px;font:600 12px/1 inherit;color:#3c424c;cursor:pointer;transition:.12s}",
      ".gwt-seg button.on{background:var(--bl);border-color:var(--bl);color:#fff}",
      ".gwt-chk{display:flex;align-items:center;gap:8px;font-size:13px;padding:6px 0;cursor:pointer}",
      ".gwt-chk input{width:16px;height:16px;accent-color:var(--bl)}",
      ".gwt-price{background:var(--ink);color:#fff;border-radius:10px;padding:15px 16px}",
      ".gwt-price .net{font:800 26px/1 Archivo,sans-serif;color:#5b92ff}",
      ".gwt-price .gr{font-size:12px;color:#c2c9d3;margin-top:5px}",
      ".gwt-price .mt{font:10px/1.5 'IBM Plex Mono',monospace;color:#8b94a3;margin-top:9px;letter-spacing:.03em}",
      ".gwt-cta{display:block;width:100%;margin-top:9px;padding:13px;background:var(--bl);color:#fff;border:0;border-radius:8px;font:700 14px/1 inherit;cursor:pointer}",
      ".gwt-cta:hover{background:#245ad0}",
      ".gwt-cta:disabled{opacity:.65;cursor:default}",
      ".gwt-mail{width:100%;margin-top:11px;padding:11px 12px;border:1px solid #3a4250;border-radius:8px;background:#fff;color:var(--ink);font:400 13px/1.2 inherit}",
      ".gwt-mail::placeholder{color:#8b94a3}",
      ".gwt-note{font-size:11px;color:#c2c9d3;margin-top:8px;line-height:1.5}",
    ].join("");
    document.head.appendChild(s);
  }

  // ── 3D-Aufbau ──
  function buildTable(THREE, cfg, r) {
    var g = new THREE.Group();
    var isBlack = cfg.color === "schwarz", color = COL[cfg.color] || COL.silber;
    var M = getProfileMats(THREE, color, isBlack), slotMat = M.slot;
    var L = cfg.L, W = cfg.W, footH = cfg.foot === "caster" ? 60 : 28, legLen = r.legLen - footH;
    if (legLen < 100) legLen = 100;
    // Profile = echte extrudierte T-Nut-Geometrie (Nut entlang der Länge). Signatur bleibt:
    // m gesetzt (slotMat) oder Nicht-Standard-Querschnitt → glatte Box.
    var box = makeBox(THREE, g, M);

    // Beine 30×30
    var lx = L / 2 - 15, lz = W / 2 - 15;
    [[-lx, -lz], [lx, -lz], [-lx, lz], [lx, lz]].forEach(function (p) {
      box(30, legLen, 30, p[0], footH + legLen / 2, p[1]);
      // Fuß
      if (cfg.foot === "caster") {
        var wheel = new THREE.Mesh(new THREE.CylinderGeometry(24, 24, 16, 20), slotMat);
        wheel.rotation.z = Math.PI / 2; wheel.position.set(p[0], 20, p[1]); g.add(wheel);
        box(20, 26, 20, p[0], footH - 5, p[1], slotMat);
      } else {
        box(26, 10, 26, p[0], 5, p[1], slotMat);
        box(16, footH - 8, 16, p[0], footH / 2, p[1], slotMat);
      }
    });

    var frameY = footH + legLen + 20;
    // Rahmen 20×40 (40 hoch): 2 Längsträger + 2 Querträger perimeter
    box(L, 40, 20, 0, frameY, -(W / 2 - 10));
    box(L, 40, 20, 0, frameY, (W / 2 - 10));
    box(20, 40, W - 40, -(L / 2 - 10), frameY, 0);
    box(20, 40, W - 40, (L / 2 - 10), frameY, 0);
    // Querträger
    for (var c = 1; c <= r.crossN; c++) {
      var cx = -L / 2 + (L * c) / (r.crossN + 1);
      box(20, 40, W - 40, cx, frameY, 0);
    }
    // Arbeitsfläche: Latten 20×40 flach, längs
    var slatY = frameY + 30, span = (r.slatN - 1) * r.pitch, z0 = -span / 2;
    for (var i = 0; i < r.slatN; i++) box(L - 6, 20, 40, 0, slatY, z0 + i * r.pitch);

    // Ablageboden: 20×40-Rahmen zwischen den Beinen (Innenflächen bündig), 20×20-Latten oben auf
    if (cfg.shelf) {
      var shY = footH + 150;                        // Rahmen-Mittenhöhe (40 hoch → Ober-K shY+20)
      var shInX = L / 2 - 30, shInZ = W / 2 - 30;   // innere Beinflächen (Beine sind 30×30)
      // Längsträger (entlang X) direkt innen an vorderer/hinterer Beinreihe, 20 tief
      box(L - 60, 40, 20, 0, shY, -(shInZ - 10));
      box(L - 60, 40, 20, 0, shY, (shInZ - 10));
      // Querträger (entlang Z) innen an linker/rechter Beinreihe, zwischen die Längsträger gesetzt
      var shZspan = Math.max(60, W - 100);          // zwischen den Innenkanten der Längsträger
      box(20, 40, shZspan, -(shInX - 10), shY, 0);
      box(20, 40, shZspan, (shInX - 10), shY, 0);
      // Latten 20×20 längs, liegen OBEN auf dem Rahmen auf (Mitte = Rahmen-OK + 10)
      var shN = r.shelfSlatN, shUse = W - 80, shSp = (shN - 1) * (shUse / Math.max(1, shN - 1)), shZ0 = -shSp / 2;
      for (var j = 0; j < shN; j++) box(L - 70, 20, 20, 0, shY + 30, shZ0 + j * (shUse / Math.max(1, shN - 1)));
    }
    // Diagonalstreben: 4 Stück, je eine pro Ecke, echtes 45°-Dreieck in der Längsträger-Ebene (X-Y)
    // zwischen Bein-Innenfläche (unten) und Rahmen-Unterseite (oben, nach innen versetzt).
    if (cfg.braces) {
      var brD = 130;                                 // Katheten-Länge (X = Y), 45° → Bar-Länge brD·√2
      var brInX = L / 2 - 30;                        // Bein-Innenfläche in X (Beine 30×30 bei ±lx)
      var brUnder = frameY - 20;                     // Rahmen-Unterseite = Bein-Oberkante
      [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (s) {
        var sx = s[0], sz = s[1];
        // Endpunkte: unten am Bein (X = sx·brInX, Y = brUnder−brD), oben am Rahmen (X nach innen um brD).
        // Bar mit Länge entlang Y bauen (glatt, m=slotMat), Mitte = Mittelpunkt der Diagonale, dann Z-Roll 45°.
        var d = box(20, brD * Math.SQRT2, 20, sx * (brInX - brD / 2), brUnder - brD / 2, sz * lz, slotMat);
        d.rotation.z = sx * Math.PI / 4;             // +Y kippt zur Tischmitte (−sx·X) → Fuß am Bein, Kopf am Rahmen
      });
    }
    // Aufbau-Spine (hinten): 2× 30×30 hoch, wachsen aus dem Rahmen (ab frameY−20) nach oben
    if (r.spineOn) {
      var spBz = -(W / 2 - 15), spBase = frameY - 20, spTop = frameY + r.spineH, spH = spTop - spBase;
      [-lx, lx].forEach(function (sx) { box(30, spH, 30, sx, spBase + spH / 2, spBz); });
      // Oberablage: von BEIDEN Spines getragen. Zwei Seitenholme (in Z) sitzen hinten auf den Spines und
      // tragen den vorderen Querholm; hinterer Querholm liegt direkt über den Spines; Latten quer darüber.
      if (r.upperOn) {
        var upY = spTop - 60;                        // Rahmenebene, 40mm unter Spine-OK (Holme 40 hoch)
        var upDepth = Math.min(220, Math.max(80, W - 120)); // Ablagetiefe (defensiv < Tischtiefe)
        var upFrontZ = spBz + upDepth;               // vordere Kante der Oberablage
        var upMidZ = spBz + upDepth / 2;
        // Seitenholme (Länge Z) über den Spines (x = ±lx): hinten von Spine getragen, tragen vorn den Frontholm
        box(20, 40, upDepth + 20, -lx, upY, upMidZ);
        box(20, 40, upDepth + 20, lx, upY, upMidZ);
        // Hinterer Querholm über den Spines + vorderer Querholm auf den Seitenholm-Enden (Länge = Spine-Abstand)
        box(L - 30, 40, 20, 0, upY, spBz);           // hinten, direkt über den Spines
        box(L - 30, 40, 20, 0, upY, upFrontZ);       // vorne, getragen von den Seitenholmen
        // Latten 20×20 QUER (Länge Z) oben auf den Holmen, über X verteilt → jede Latte liegt auf beiden Holmen
        var upN = Math.max(2, r.upperSlatN), upInX = L / 2 - 40, upStep = (2 * upInX) / (upN - 1);
        for (var u = 0; u < upN; u++) box(20, 20, upDepth, -upInX + u * upStep, upY + 30, upMidZ);
      }
    }
    return g;
  }

  // ── Init einer Instanz ──
  function init(root) {
    var THREE = window.THREE;
    injectCss();
    root.classList.add("gwt");
    root.innerHTML =
      '<div class="gwt-stage"><div class="gwt-hint">Ziehen zum Drehen · Scrollen zum Zoomen</div></div>' +
      '<div class="gwt-panel">' +
      '<div class="gwt-grp"><h4>Maße</h4>' +
      '<div class="gwt-row"><span>Länge</span><b data-o="L">1500 mm</b></div><input class="gwt-slider" type="range" min="800" max="2400" step="50" value="1500" data-c="L">' +
      '<div class="gwt-row"><span>Tiefe</span><b data-o="W">750 mm</b></div><input class="gwt-slider" type="range" min="500" max="900" step="25" value="750" data-c="W">' +
      '<div class="gwt-row"><span>Höhe</span><b data-o="H">900 mm</b></div><input class="gwt-slider" type="range" min="700" max="1100" step="10" value="900" data-c="H"></div>' +
      '<div class="gwt-grp"><h4>Ausführung</h4>' +
      '<div class="gwt-row"><span>Farbe</span></div><div class="gwt-seg" data-seg="color"><button data-v="silber" class="on">Silber</button><button data-v="schwarz">Schwarz</button></div>' +
      '<div class="gwt-row" style="margin-top:10px"><span>Unterbau</span></div><div class="gwt-seg" data-seg="foot"><button data-v="level" class="on">Stellfüße</button><button data-v="caster">Rollen</button></div>' +
      '<div class="gwt-row" style="margin-top:10px"><span>Deckung</span></div><div class="gwt-seg" data-seg="coverage"><button data-v="offen">Gitter</button><button data-v="standard" class="on">Standard</button><button data-v="voll">Voll</button></div></div>' +
      '<div class="gwt-grp"><h4>Aufbau &amp; Optionen</h4>' +
      '<label class="gwt-chk"><input type="checkbox" data-opt="spine">Aufbau-Spine (hinten) — macht den Tisch zur Workstation</label>' +
      '<label class="gwt-chk"><input type="checkbox" data-opt="upperShelf">Oberablage (auf dem Spine)</label>' +
      '<label class="gwt-chk"><input type="checkbox" data-opt="shelf">Ablageboden unten</label>' +
      '<label class="gwt-chk"><input type="checkbox" data-opt="braces">Diagonalstreben (Schwerlast)</label></div>' +
      '<div class="gwt-price"><div class="net" data-o="net">Auf Anfrage</div><div class="gr" data-o="gross"></div><div class="mt" data-o="meta"></div>' +
      '<input class="gwt-mail" type="email" inputmode="email" autocomplete="email" placeholder="E-Mail für das Angebot" data-mail>' +
      '<button class="gwt-cta" data-cta>Angebot anfordern</button>' +
      '<div class="gwt-note" data-o="hinweis">Wir prüfen Ihre Konfiguration und melden uns mit einem Angebot.</div></div>' +
      '</div>';

    var stage = root.querySelector(".gwt-stage");
    var cfg = { L: 1500, W: 750, H: 900, color: "silber", foot: "level", coverage: "standard", shelf: false, braces: false, spine: false, upperShelf: false };

    // Scene
    var scene = new THREE.Scene();
    var cam = new THREE.PerspectiveCamera(38, 1, 10, 12000);
    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    stage.appendChild(renderer.domElement);
    // Umgebung (Gradient-Equirect für Metall-Glanz)
    var cv = document.createElement("canvas"); cv.width = 16; cv.height = 128;
    var cx = cv.getContext("2d"); var gr = cx.createLinearGradient(0, 0, 0, 128);
    gr.addColorStop(0, "#ffffff"); gr.addColorStop(0.5, "#eef2f6"); gr.addColorStop(1, "#cbd2da");
    cx.fillStyle = gr; cx.fillRect(0, 0, 16, 128);
    var env = new THREE.CanvasTexture(cv); env.mapping = THREE.EquirectangularReflectionMapping; scene.environment = env;
    scene.add(new THREE.HemisphereLight(0xffffff, 0x9aa4b2, 1.1));
    var key = new THREE.DirectionalLight(0xffffff, 1.9); key.position.set(1, 2, 1.4); scene.add(key);
    var rim = new THREE.DirectionalLight(0xbcd0ff, 0.5); rim.position.set(-1.5, 0.8, -1); scene.add(rim);

    var group = null;
    function rebuild() {
      var r = compute(cfg);
      if (group) { scene.remove(group); group.traverse(function (o) { if (o.geometry && !(o.geometry.userData && o.geometry.userData.shared)) o.geometry.dispose(); }); }
      group = buildTable(THREE, cfg, r);
      // zentrieren
      var bb = new THREE.Box3().setFromObject(group); var ctr = bb.getCenter(new THREE.Vector3());
      group.position.set(-ctr.x, -ctr.y, -ctr.z); scene.add(group);
      // Preis-UI — Preise sind bewusst NICHT ausgewiesen, solange die Bauform
      // nicht final ist. Die technischen Kennzahlen bleiben sichtbar, damit die
      // Konfiguration trotzdem greifbar ist.
      root.querySelector('[data-o="net"]').textContent = "Auf Anfrage";
      root.querySelector('[data-o="gross"]').textContent = "Angebot innerhalb von 24 Stunden";
      root.querySelector('[data-o="meta"]').textContent =
        cfg.L + "×" + cfg.W + "×" + cfg.H + " mm · " + r.meters + " m Profil · ~" + r.weightKg + " kg · Bausatz";
      // Nach einer Änderung ist die vorige Anfrage überholt → Knopf wieder scharf.
      root.dispatchEvent(new CustomEvent("gwtable:reset"));
      return bb;
    }
    var box0 = rebuild();
    var radius = box0.getSize(new THREE.Vector3()).length();

    // Orbit (custom)
    var az = 0.7, pol = 1.0, dist = radius * 1.18, drag = false, px = 0, py = 0, idle = 0;
    function applyCam() {
      pol = clamp(pol, 0.42, 1.28);
      cam.position.set(dist * Math.sin(pol) * Math.sin(az), dist * Math.cos(pol), dist * Math.sin(pol) * Math.cos(az));
      cam.lookAt(0, 0, 0);
    }
    var pts = {}, pinchD = 0;
    function npts() { return Object.keys(pts).length; }
    function pdist() { var k = Object.keys(pts); var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); }
    renderer.domElement.addEventListener("pointerdown", function (e) { pts[e.pointerId] = { x: e.clientX, y: e.clientY }; idle = 0; if (npts() === 1) drag = true; else if (npts() === 2) { drag = false; pinchD = pdist(); } e.target.setPointerCapture(e.pointerId); });
    renderer.domElement.addEventListener("pointermove", function (e) { var p = pts[e.pointerId]; if (!p) return; idle = 0; if (npts() >= 2) { p.x = e.clientX; p.y = e.clientY; var nd = pdist(); if (pinchD > 0 && nd > 0) dist = clamp(dist * (pinchD / nd), radius * 0.6, radius * 2.4); pinchD = nd; } else { az -= (e.clientX - p.x) * 0.01; pol -= (e.clientY - p.y) * 0.01; p.x = e.clientX; p.y = e.clientY; } });
    function pend(e) { delete pts[e.pointerId]; if (npts() < 2) pinchD = 0; drag = npts() >= 1; }
    renderer.domElement.addEventListener("pointerup", pend);
    renderer.domElement.addEventListener("pointercancel", pend);
    renderer.domElement.addEventListener("wheel", function (e) { e.preventDefault(); dist = clamp(dist * (1 + (e.deltaY > 0 ? 0.1 : -0.1)), radius * 0.6, radius * 2.4); idle = 0; }, { passive: false });

    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight || 440;
      renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix();
    }
    window.addEventListener("resize", resize); resize();

    (function loop() {
      requestAnimationFrame(loop);
      idle++; if (!drag && idle > 120) az += 0.0016; // sanfte Auto-Rotation im Leerlauf
      applyCam(); renderer.render(scene, cam);
    })();

    // Controls
    root.querySelectorAll(".gwt-slider").forEach(function (sl) {
      sl.addEventListener("input", function () {
        cfg[sl.dataset.c] = +sl.value;
        root.querySelector('[data-o="' + sl.dataset.c + '"]').textContent = sl.value + " mm";
        var bb = rebuild(); radius = bb.getSize(new THREE.Vector3()).length(); dist = clamp(dist, radius * 0.6, radius * 2.4);
      });
    });
    root.querySelectorAll("[data-seg]").forEach(function (seg) {
      seg.addEventListener("click", function (e) {
        var b = e.target.closest("button"); if (!b) return;
        seg.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); }); b.classList.add("on");
        cfg[seg.dataset.seg] = b.dataset.v; rebuild();
      });
    });
    root.querySelectorAll("[data-opt]").forEach(function (ck) {
      ck.addEventListener("change", function () {
        cfg[ck.dataset.opt] = ck.checked;
        if (ck.dataset.opt === "upperShelf" && ck.checked) { cfg.spine = true; var sp = root.querySelector('[data-opt="spine"]'); if (sp) sp.checked = true; }
        var bb = rebuild(); radius = bb.getSize(new THREE.Vector3()).length(); dist = radius * 1.2;
      });
    });
    // Bewusst KEIN Checkout: Solange die Bauform nicht final ist, wird im Shop
    // kein Preis zugesagt. Der Knopf sammelt die Konfiguration + E-Mail ein,
    // das Angebot geht danach von Hand raus.
    var cta = root.querySelector("[data-cta]");
    var mail = root.querySelector("[data-mail]");
    var hinweis = root.querySelector('[data-o="hinweis"]');
    var hinweisText = hinweis.textContent;
    // Angemeldet: E-Mail vorbelegen; die Anfrage wird über das Konto-Ticket dem Konto zugeordnet.
    if (root.getAttribute("data-konto-email") && !mail.value) mail.value = root.getAttribute("data-konto-email");

    cta.addEventListener("click", function () {
      var adresse = (mail.value || "").trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adresse)) {
        hinweis.textContent = "Bitte eine E-Mail-Adresse angeben, damit wir das Angebot schicken können.";
        mail.focus();
        return;
      }
      var r = compute(cfg);
      root.dispatchEvent(new CustomEvent("gwtable:add", { bubbles: true, detail: { config: cfg, price: r } }));
      if (window.GWTableAddToCart) { window.GWTableAddToCart(cfg, r); return; }
      var api = (window.GW_TABLE_API || "https://quote.gebertweschka.de") + "/api/table-quote";
      var orig = cta.textContent;
      cta.disabled = true; cta.textContent = "Anfrage wird gesendet …";
      hinweis.textContent = hinweisText;
      var ticket = root.getAttribute("data-konto-email") && window.GWKonto
        ? window.GWKonto.ticket().catch(function () { return null; }) : Promise.resolve(null);
      ticket.then(function (t) {
        return fetch(api, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          // inquiry: true → Server legt KEINEN Bezahllink an und nennt keinen Preis.
          body: JSON.stringify({ config: cfg, email: adresse, inquiry: true, kontoTicket: t && t.ticket ? t.ticket : undefined }),
        });
      })
        .then(function (res) { return res.json(); })
        .then(function (d) {
          if (!d || d.error) throw new Error(d && d.error ? d.error : "Fehler");
          cta.textContent = "Anfrage ist raus ✓";
          root.querySelector('[data-o="net"]').textContent = "Anfrage eingegangen";
          root.querySelector('[data-o="gross"]').textContent =
            d.refNumber ? "Referenz " + d.refNumber : "";
          hinweis.textContent = "Danke — wir melden uns innerhalb von 24 Stunden an "
            + adresse + ". Ändern Sie die Konfiguration, können Sie erneut anfragen.";
        })
        .catch(function () {
          cta.disabled = false; cta.textContent = orig;
          hinweis.textContent = "Das hat gerade nicht geklappt — bitte erneut versuchen "
            + "oder direkt an business@gebertweschka.de schreiben.";
        });
    });
    // Nach jeder Änderung wieder anfragbar machen.
    root.addEventListener("gwtable:reset", function () {
      cta.disabled = false; cta.textContent = "Angebot anfordern";
      hinweis.textContent = hinweisText;
    });
  }

  // Three self-hosted laden (wie gw-3d.js): dynamic import() ist auf dem Storefront
  // teils kaputt → echtes <script type="module"> injizieren, das window.THREE setzt.
  function ensureThree() {
    if (window.THREE || window.__gwThreeInjected) return;
    var url = window.GW_THREE_URL; if (!url) return;
    window.__gwThreeInjected = 1;
    var s = document.createElement("script"); s.type = "module";
    s.textContent = 'import * as T from "' + url + '"; window.THREE = T; window.dispatchEvent(new Event("gw-three-ready"));';
    document.head.appendChild(s);
  }
  function ready(cb) { ensureThree(); if (window.THREE) return cb(); var n = 0; var t = setInterval(function () { ensureThree(); if (window.THREE || n++ > 200) { clearInterval(t); if (window.THREE) cb(); } }, 50); }
  function boot() { document.querySelectorAll("[data-gw-table]").forEach(function (el) { if (!el.__gwt) { el.__gwt = 1; ready(function () { init(el); }); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  window.GWTableConfigurator = { boot: boot, compute: compute };
})();
